export default __webpack_public_path__ + "static/media/resume.3cde5e4c.pdf";